import Exception from './Exception';
/**
 * Custom Error class of type Exception.
 */
class WriterException extends Exception {
}
WriterException.kind = 'WriterException';
export default WriterException;
